import { useQueries } from '@tanstack/react-query'
import moment from 'moment'
import { fetcher } from 'repositories/BerthApi/berthApiClient'
import { getUnassignedBookingsEndpoint } from 'repositories/BerthApi/getUnassignedBookings/endpoint'
import type { GetUnassignedBookingsResponse } from 'repositories/BerthApi/getUnassignedBookings/type'
import { bookingKeys } from 'repositories/queryKeys'

const UNASSIGNED_BOOKINGS_FETCH_LIMIT = 100

export function useUnassignedBookings(
  tenantId: string | null,
  warehouseId: string | null,
  date: string
) {
  const bookingDate = date.replace(/-/g, '')
  const baseMoment = moment(date, 'YYYY-MM-DD')

  // 前日・当日・翌日の3日分を並列取得し、前後日をキャッシュしてページ切替を高速化する
  const targetDates = [
    baseMoment.clone().add(-1, 'days').format('YYYYMMDD'),
    bookingDate,
    baseMoment.clone().add(1, 'days').format('YYYYMMDD'),
  ]

  const results = useQueries({
    queries: targetDates.map((d) => ({
      queryKey: bookingKeys.unassignedByParams(tenantId ?? '', warehouseId ?? '', d),
      queryFn: () =>
        fetcher<GetUnassignedBookingsResponse>(
          getUnassignedBookingsEndpoint({
            tenantId: Number(tenantId!),
            warehouseId: Number(warehouseId!),
            bookingDate: d,
            limit: UNASSIGNED_BOOKINGS_FETCH_LIMIT,
          })
        ),
      enabled: !!tenantId && !!warehouseId,
      staleTime: d === bookingDate ? 0 : 5 * 60 * 1000,
      refetchInterval: d === bookingDate ? 15000 : (false as const),
      refetchIntervalInBackground: false,
    })),
  })

  const todayIndex = targetDates.indexOf(bookingDate)
  const { data, error, isLoading } = results[todayIndex]

  return {
    unassignedBookings: data?.data?.bookings ?? [],
    total: data?.data?.total ?? 0,
    isLoading,
    error,
  }
}
